import {Housing} from './types';

type HousingNameFields = {
  display_name?: string | null;
  name?: string | null;
  property_name?: string | null;
  housing_name?: string | null;
};

const COMMERCIAL_NAME_FIELDS = ['display_name'] as const;
const PROPERTY_NAME_FIELDS = ['name', 'property_name', 'housing_name'] as const;

function findFilled(values: (string | null | undefined)[]) {
  return values.find((value): value is string => Boolean(value));
}

function findFilledField(
  sources: (HousingNameFields | null | undefined)[],
  fields: readonly (keyof HousingNameFields)[],
) {
  return findFilled(sources.flatMap(source => fields.map(field => source?.[field])));
}

export function resolveHousingName(...sources: (HousingNameFields | null | undefined)[]) {
  return (
    findFilledField(sources, COMMERCIAL_NAME_FIELDS) ??
    findFilledField(sources, PROPERTY_NAME_FIELDS)
  );
}

function getIsPoliceEnabled(housing?: Housing) {
  const isEnabled = housing?.is_police_registration_enabled;
  return Boolean(isEnabled);
}

function getPoliceType(housing?: Housing): string {
  const type = housing?.police_account_type;

  if (!type) {
    return '';
  }
  return type;
}

export function getPoliceTypeIfPoliceActive(housing?: Housing) {
  if (!getIsPoliceEnabled(housing)) {
    return '';
  }
  return getPoliceType(housing);
}
